const PagingController = function () {
    let maximumVisiblePages = 10;

    this.$onInit = function () {
        this.selectedIndex = 0;
        this.pagingIsEnabled = (this.pageSize > 0 && !this.printPreview);
        this.setupPages();
        this.calculatePageRange();
    };

    this.$onChanges = function () {
        this.setupPages();
        this.calculatePageRange();
    };

    this.setupPages = function () {
        let maxIndex,
            currentIndex;

        this.numberOfPages = Math.ceil(this.source.length / this.pageSize);
        if(this.numberOfPages === 0){
            this.numberOfPages = 1;
        }
        this.pageList = _.map(_.times(this.numberOfPages), function (index) {
            return {
                index: index,
                label: index + 1
            };
        });

        maxIndex = this.pageList.length - 1;
        currentIndex = this.selectedIndex;

        if (currentIndex > maxIndex) {
            this.selectedIndex = maxIndex;
        }
    };

    this.onSelectPage = function (page) {
        this.selectedIndex = this.pageList.indexOf(page);
        this.calculatePageRange();
    };

    this.onNextPage = function () {
        let maxIndex = this.pageList.length - 1,
            currentIndex = this.selectedIndex,
            isAllowed = currentIndex < maxIndex;

        this.selectedIndex = isAllowed ? currentIndex + 1 : maxIndex;
        this.calculatePageRange();
    };

    this.onPreviousPage = function () {
        this.selectedIndex = this.selectedIndex > 0 ? this.selectedIndex - 1 : 0;
        this.calculatePageRange();
    };

    this.calculatePageRange = function () {
        let startIndexOrig = this.startIndex,
            endIndexOrig = this.endIndex;
        this.startIndex = this.selectedIndex * this.pageSize;
        this.endIndex = this.startIndex + this.pageSize - 1;

        if (this.endIndex > this.source.length - 1 && this.source.length - 1 >= 0) {
            this.endIndex = this.source.length - 1;
        }

        let startPage = 0,
            endPage = this.pageList.length,
            isMaximumVisiblePages = maximumVisiblePages < endPage;

        if (isMaximumVisiblePages) {
            // Current page is displayed in the middle of the visible ones
            startPage = Math.max(this.selectedIndex - Math.floor(maximumVisiblePages / 2), 0);
            endPage = startPage + maximumVisiblePages;

            // Adjust if limit is exceeded
            if (endPage > this.pageList.length) {
                endPage = this.pageList.length;
                startPage = endPage - maximumVisiblePages;
            }
        }

        this.visiblePageList = _.slice(_.clone(this.pageList), startPage, endPage);

        if(startIndexOrig !== this.startIndex || endIndexOrig !== this.endIndex) {
            this.onChange({
                startIndex: this.startIndex,
                endIndex: this.endIndex
            });
        }
    };
};

angular.module('umFormViewer')
    .controller('pagingController', PagingController);
